<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <g v-if="weight === 'REGULAR'">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.10011 7.50098C7.10011 4.79478 9.29391 2.60098 12.0001 2.60098C14.7063 2.60098 16.9001 4.79478 16.9001 7.50098C16.9001 10.2072 14.7063 12.401 12.0001 12.401C9.29391 12.401 7.10011 10.2072 7.10011 7.50098ZM12.0001 4.40097C10.288 4.40097 8.90011 5.78889 8.90011 7.50098C8.90011 9.21306 10.288 10.601 12.0001 10.601C13.7122 10.601 15.1001 9.21306 15.1001 7.50098C15.1001 5.78889 13.7122 4.40097 12.0001 4.40097Z"
                fill="currentColor"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.91637 14.9215C7.53064 14.052 9.68808 13.5994 12 13.5994C14.3119 13.5994 16.4694 14.052 18.0836 14.9215C19.6968 15.7904 20.9 17.1656 20.9 18.9994L20.9 19.3263C20.9 19.5129 20.9 19.7029 20.8868 19.8654C20.872 20.0461 20.8364 20.2703 20.7201 20.4985C20.562 20.809 20.3096 21.0614 19.9991 21.2196C19.7709 21.3359 19.5467 21.3715 19.366 21.3863C19.2035 21.3996 19.0135 21.3995 18.8269 21.3995L5.17337 21.4003C4.98672 21.4004 4.79669 21.4004 4.63425 21.3871C4.45352 21.3724 4.22927 21.3368 4.00102 21.2205C3.69053 21.0624 3.4381 20.8099 3.27989 20.4995C3.16359 20.2712 3.12802 20.047 3.11325 19.8662C3.09998 19.7038 3.10001 19.5138 3.10004 19.3271L3.10004 18.9994C3.10004 17.1656 4.30324 15.7904 5.91637 14.9215ZM6.76998 16.5062C5.48769 17.197 4.90004 18.0718 4.90004 18.9994L4.90185 19.5985L19.0982 19.5977L19.1 18.9994C19.1 18.0718 18.5123 17.197 17.23 16.5062C15.9489 15.8161 14.1063 15.3994 12 15.3994C9.89368 15.3994 8.05113 15.8161 6.76998 16.5062Z"
                fill="currentColor"
            />
            <path
                d="M21.4002 8.50039C21.4002 8.00333 20.9972 7.60039 20.5002 7.60039C20.0031 7.60039 19.6002 8.00333 19.6002 8.50039V10.1004H18.0002C17.5031 10.1004 17.1002 10.5033 17.1002 11.0004C17.1002 11.4974 17.5031 11.9004 18.0002 11.9004H19.6002V13.5004C19.6002 13.9974 20.0031 14.4004 20.5002 14.4004C20.9972 14.4004 21.4002 13.9974 21.4002 13.5004V11.9004H23.0002C23.4972 11.9004 23.9002 11.4974 23.9002 11.0004C23.9002 10.5033 23.4972 10.1004 23.0002 10.1004H21.4002V8.50039Z"
                fill="currentColor"
            />
        </g>
        <g v-else-if="weight === 'FILL'">
            <path
                d="M12 2.85293C9.56998 2.85293 7.60004 4.82288 7.60004 7.25293C7.60004 9.68298 9.56998 11.6529 12 11.6529C14.4301 11.6529 16.4 9.68298 16.4 7.25293C16.4 4.82288 14.4301 2.85293 12 2.85293Z"
                fill="currentColor"
            />
            <path
                d="M5.91631 14.9211C7.53058 14.0516 9.68801 13.599 11.9999 13.599C14.3119 13.599 16.4693 14.0516 18.0836 14.9211C19.6967 15.7901 20.8999 17.1652 20.8999 18.999L20.8999 19.3259C20.8999 19.5125 20.9 19.7026 20.8867 19.865C20.8719 20.0457 20.8364 20.2699 20.7201 20.4982C20.5619 20.8086 20.3095 21.061 19.9991 21.2192C19.7708 21.3355 19.5466 21.3711 19.3659 21.3859C19.2035 21.3992 19.0135 21.3991 18.8268 21.3991L5.17331 21.3999C4.98666 21.4 4.79663 21.4 4.63418 21.3868C4.45346 21.372 4.22921 21.3364 4.00095 21.2201C3.69047 21.062 3.43804 20.8095 3.27983 20.4991C3.16353 20.2708 3.12796 20.0466 3.11319 19.8658C3.09992 19.7034 3.09995 19.5134 3.09998 19.3267L3.09998 18.999C3.09998 17.1652 4.30318 15.7901 5.91631 14.9211Z"
                fill="currentColor"
            />
            <path
                d="M21.4001 8.50039C21.4001 8.00333 20.9972 7.60039 20.5001 7.60039C20.0031 7.60039 19.6001 8.00333 19.6001 8.50039V10.1004H18.0001C17.5031 10.1004 17.1001 10.5033 17.1001 11.0004C17.1001 11.4974 17.5031 11.9004 18.0001 11.9004H19.6001V13.5004C19.6001 13.9974 20.0031 14.4004 20.5001 14.4004C20.9972 14.4004 21.4001 13.9974 21.4001 13.5004V11.9004H23.0001C23.4972 11.9004 23.9001 11.4974 23.9001 11.0004C23.9001 10.5033 23.4972 10.1004 23.0001 10.1004H21.4001V8.50039Z"
                fill="currentColor"
            />
        </g>
    </svg>
</template>

<script>
export default {
    name: 'person-add-icon',
    props: {
        width: {
            type: [String, Number],
            default: 24,
        },
        height: {
            type: [String, Number],
            default: 24,
        },
        color: {
            type: String,
            default: 'text-black',
        },
        weight: {
            type: String,
            default: 'REGULAR',
        },
    },
};
</script>
